module.exports = __webpack_public_path__ + "static/media/2.d9ab65e8.png";